var map = {
	"./Version (7) - Snape Insult_00.jpg": 1269,
	"./Version (7) - Snape Insult_01.jpg": 1270,
	"./Version (7) - Snape Insult_02.jpg": 1271,
	"./Version (7) - Snape Insult_03.jpg": 1272,
	"./Version (7) - Snape Insult_04.jpg": 1273,
	"./Version (7) - Snape Insult_05.jpg": 1274,
	"./gallery_00.jpg": 1275,
	"./gallery_01.jpg": 1276,
	"./gallery_02.jpg": 1277,
	"./gallery_03.jpg": 1278,
	"./gallery_04.jpg": 1279,
	"./gallery_05.jpg": 1280
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1268;